module.exports = __webpack_public_path__ + "img/topup_desktop_failed.7c67cad7.svg";